package com.example.socialmediaapp

import kotlinx.browser.localStorage
import kotlinx.datetime.Clock

class JsPlatform : Platform {
    override val name: String = "Web with Kotlin/JS"
    override val isAdminDomain: Boolean
        get() = try {
            kotlinx.browser.window.location.hostname.startsWith("admin.")
        } catch (e: Exception) {
            false
        }
}

actual fun getPlatform(): Platform = JsPlatform()

// Top-level eager property forces Clock.System initialization at module load time,
// preventing Kotlin/JS DCE from stripping its init code before Ktor accesses it.
@OptIn(ExperimentalJsExport::class, ExperimentalStdlibApi::class)
@EagerInitialization
private val _clockSystem = run {
    console.log("[INIT] Clock.System eager initialization started")
    val c = Clock.System
    console.log("[INIT] Clock.System eager initialization complete: $c")
    c
}

actual fun currentTimeMillis(): Long {
    val ms = _clockSystem.now().toEpochMilliseconds()
    console.log("[TIME] currentTimeMillis() = $ms")
    return ms
}

actual fun getLocalDateComponents(timestamp: Long): LocalDateComponents {
    val d = kotlin.js.Date(timestamp.toDouble())
    return LocalDateComponents(
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        dayOfWeekSun0 = d.getDay()
    )
}

actual fun openVideoCall(roomUrl: String, isVideo: Boolean) {
    kotlinx.browser.window.open(roomUrl, "_blank")
}

// ============================================
// TOKEN STORAGE - Web (JS)
// ============================================

actual class TokenStorage actual constructor() {
    actual fun saveToken(token: String) = localStorage.setItem("jwt_token", token)
    actual fun getToken(): String? = localStorage.getItem("jwt_token")
    actual fun clearToken() = localStorage.clear()
    actual fun saveUserId(userId: String) = localStorage.setItem("user_id", userId)
    actual fun getUserId(): String? = localStorage.getItem("user_id")
    actual fun saveUsername(username: String) = localStorage.setItem("username", username)
    actual fun getUsername(): String? = localStorage.getItem("username")

    actual fun getDeviceId(): String? {
        return "MacD2026A"
    }

    actual fun getHandshake(): String? {
        return "thunder"
    }
}